"use client";

import { Controller } from "react-hook-form";
import { WcPlateEditor, type WcPlateEditorProps } from "./WcPlateEditor";

interface WcPlateEditorControllerProps extends Omit<WcPlateEditorProps, "onChange"> {
  name: string;
  control: any;
  onSavePressed?: any;
  onCustomChange?: any;
}

interface SlateVal {
  text?: string;
  color?: string;
  marks?: string[];
  italic?: boolean;
  underlined?: boolean;
  bold?: boolean;
  strikethrough?: boolean;
  type?: string;
  children?: SlateVal[];
}

export const WcPlateEditorController = ({
  name,
  control,
  onSavePressed,
  onCustomChange,
  ...extraEditorProps
}: WcPlateEditorControllerProps) => (
  <Controller
    name={name}
    control={control}
    render={({ field: { onChange, value }, fieldState: { error }, formState }) => {
      // const isSlateVal = (val: any): boolean | undefined => {
      //   if (!Array.isArray(val)) return undefined;
      //   return val.every((v) => v.type === undefined || v.type === null) ?? false;
      // };

      // const getConvertedSlateVals = (val: SlateVal[]): Value => {
      //   let slateVals: any[] = [];
      //   val.forEach((v) => {
      //     if (v.children) {
      //       slateVals = [...slateVals, ...getConvertedSlateVals(v.children)];
      //     }
      //     if (v.text) {
      //       slateVals.push({
      //         children: [
      //           {
      //             text: v.text,
      //             ...(v.bold && { bold: true }),
      //             ...(v.italic && { italic: true }),
      //             ...(v.underlined && { underline: true }),
      //             ...(v.strikethrough && { strikethrough: true }),
      //           },
      //         ],
      //         type: v.type ?? "p",
      //       });
      //     }
      //   });
      //   return slateVals as Value;
      // };

      // // Convert legacy format to new Plate format
      // let processedValue: Value = value;

      // if (isSlateVal(value)) {
      //   // Convert to slate value
      //   processedValue = getConvertedSlateVals(value);
      // } else if (isSlateVal(value) === undefined || !value) {
      //   // We don't know the value type yet, so we set it to an empty array
      //   processedValue = [
      //     {
      //       type: "p",
      //       children: [{ text: "" }],
      //     },
      //   ];
      // }

      return (
        <WcPlateEditor
          {...extraEditorProps}
          initialValue={value}
          onChange={(val) => {
            onChange(val);
            if (onSavePressed) onSavePressed();
            if (onCustomChange) onCustomChange();
          }}
        />
      );
    }}
  />
);
